// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3J-um","footer":"Form_footer__3AEVb"};